import { Component, Input, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { HasImagePipe, ItemPricePipe } from '../../../pipes';
import { DataViewModule } from 'primeng/dataview';
import { DividerModule } from 'primeng/divider';
import { DialogModule } from 'primeng/dialog';
import { NgxAimOverviewClass } from './ngx-aim-overview.class';
import { CurrencyPipe, NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';

@Component({
  selector: 'ngx-aim-overview',
  standalone: true,
  imports: [
    ButtonModule,
    HasImagePipe,
    DataViewModule,
    DividerModule,
    DialogModule,
    CurrencyPipe,
    NgClass,
    ItemPricePipe,
    FormsModule,
    CheckboxModule,
  ],
  templateUrl: './ngx-aim-overview.component.html',
  styleUrls: ['./ngx-aim-overview.component.css']
})
export class NgxAimOverviewComponent extends NgxAimOverviewClass implements OnInit {
  @Input({ required: true })
  override completeUrl: string = '';

  @Input()
  override iAgreeMessage: string = '';

  ngOnInit() {
    this.init();
  }
}
